import { Mail, Phone, MapPin } from 'lucide-react';

export default function Contact() {
  return (
    <div>
      <section className="bg-gradient-to-br from-blue-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-brand-dark mb-6">Contact Us</h1>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto">
              Have questions? We're here to help. Reach out to us anytime.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-brand-dark mb-6 font-display">Get In Touch</h2>
              <p className="text-slate-600 mb-8">
                Whether you have questions about our courses, want to schedule a demo class, or need guidance on choosing the right program, we're here to assist you.
              </p>

              <div className="space-y-6">
                <div data-testid="contact-email" className="flex items-start">
                  <div className="w-12 h-12 bg-brand-blue/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Mail className="h-6 w-6 text-brand-blue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-dark mb-1">Email</h3>
                    <a href="mailto:kaushaltutor@gmail.com" className="text-slate-600 hover:text-brand-blue transition-colors">
                      kaushaltutor@gmail.com
                    </a>
                  </div>
                </div>

                <div data-testid="contact-phone" className="flex items-start">
                  <div className="w-12 h-12 bg-brand-blue/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Phone className="h-6 w-6 text-brand-blue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-dark mb-1">Phone</h3>
                    <a href="tel:+919693339188" className="text-slate-600 hover:text-brand-blue transition-colors">
                      +91 9693339188
                    </a>
                  </div>
                </div>

                <div data-testid="contact-address" className="flex items-start">
                  <div className="w-12 h-12 bg-brand-blue/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <MapPin className="h-6 w-6 text-brand-blue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-brand-dark mb-1">Location</h3>
                    <p className="text-slate-600">
                      Available for students across India and internationally
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-10">
                <h3 className="text-xl font-semibold text-brand-dark mb-4 font-display">Office Hours</h3>
                <div className="space-y-2 text-slate-600">
                  <p>Monday - Friday: 9:00 AM - 8:00 PM</p>
                  <p>Saturday: 10:00 AM - 6:00 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>

            <div className="feature-card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.3634765326785!2d77.37135731508092!3d28.61395599242884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sNoida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1642069595585!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: '1rem' }}
                allowFullScreen=""
                loading="lazy"
                title="Tutor Flex Location"
                data-testid="contact-map"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-surface">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-brand-dark mb-4">Prefer to Enroll Directly?</h2>
          <p className="text-slate-600 mb-6">
            Skip the wait and start your learning journey today
          </p>
          <a href="/enroll">
            <button data-testid="contact-enroll-btn" className="btn-primary">
              Enroll Now
            </button>
          </a>
        </div>
      </section>
    </div>
  );
}
